import { TextProps } from '@components/Text/Text';
import { DocumentAddedBy } from '@models/Document.model';
import { T_COLOR_SHADES } from '@styles/colors/themes/beam/beam-flat';
import { CellText } from '../components/CellText';
import { CellGroup } from '../components/DocumentsBody/DocumentsBody.styles';
import { getSourceIcon } from './getSourceIcon';

interface SourceLabelProps extends TextProps {
  addedBy: DocumentAddedBy;
  value: string;
  defaultColor?: T_COLOR_SHADES;
}
export function SourceLabel(props: SourceLabelProps) {
  const { addedBy, value, defaultColor, ...rest } = props;
  const { iconJsx, color = defaultColor } = getSourceIcon(addedBy);
  return (
    <CellGroup>
      {iconJsx}
      <CellText textColor={color} {...rest}>
        {value}
      </CellText>
    </CellGroup>
  );
}
